import type { Entity } from "types";

export abstract class OnboardingEntity implements Partial<Entity> {
    public readonly pki: Entity['pki'] | undefined;

    public constructor({
        pki
    }: Partial<Entity>) {
        this.pki = pki;
    }
}
